module.exports = __webpack_public_path__ + "static/media/filters.ec9cd22a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/filters.mp4
// module id = 368
// module chunks = 0